/**
 * Representation of the Artist Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { Artist } 

import { ImageList } from './ImageList.js'

/** Artist Entity */
class Artist {

    constructor(model, data) {
		// Properties
		this.model = model;
        this.id = data.id;
        
        this.lastName = data.lastName != null? data.lastName.trim() : "";
        this.middleName = data.middleName;
        this.firstName = data.firstName;
        this.maidenName = data.maidenName;
        
        this.descriptionDE = data.descriptionDE != null? data.descriptionDE.trim() : "";
        this.descriptionEN = data.descriptionEN != null? data.descriptionEN.trim() : "";
		this.descriptionFR = data.descriptionFR != null? data.descriptionFR.trim() : "";
		
        this.link = data.link;

        this.birthYear = data.birthYear;
        this.birthLocation = data.birthLocation;
        this.deathYear = data.deathYear;
        this.deathLocation = data.deathLocation;
        
        this.image = new ImageList(data.image);

        // Relations
        this.tags = [];
        this.works = [];
    }

	// Basic Getters
	
	getID() {
		return this.id;
	}
	
	getLastName() {
		return this.lastName;
	}
	
	getMiddleName() {
		return this.middleName;
	}
	
	getFirstName() {
		return this.firstName;
	}
	
	getMaidenName() {
		return this.maidenName;
	}
	
	getDescription() {
		if (this.model.getLang() == 'en') {
			return this.descriptionEN;
		} else if (this.model.getLang() == 'fr') {
			return this.descriptionFR;
		} else {
			return this.descriptionDE;
		}
	}
	
	getLink() {
		if (this.link == '') {
			return '';
		}
		if (this.link.indexOf('http') != 0) {
			return "http://" + this.link;
		} else {			
			return this.link;
		}
	}

	getBirthYear() {
		return this.birthYear;
	}
	
	getBirthLocation() {
		return this.birthLocation;
	}
	
	getDeathYear() {
		return this.deathYear;
	}
	
	getDeathLocation() {
		return this.deathLocation;
	}
	
	getImage() {
		return this.image;
	}
	
	// Relations
	
	getTags() {
		return this.tags;
	}
	
	addTag(tag) {
		this.tags.push(tag);
	}
	
	getWorks() {
		return this.works;
	}
	
	addWork(work) {
		this.works.push(work);
	}
	
	// Utilities

	/** Get the basic (unencoded) URL Term form for this entity */
	getURLTerm() {
		return this.getFullName().trim().replace(/ /g, "_").toLowerCase();		
	}

	/** Equality Test Used for URL Resovling */
	acceptURLTerm(term) {
		return this.getURLTerm() == term;
	}

	getFullName() {
		let buffer = '';
		if (this.getFirstName() != '') {
			buffer += this.getFirstName() + ' ';
		}
		if (this.getMiddleName() != '') {
			buffer += this.getMiddleName() + ' ';
		}
		if (this.getLastName() != '') {
			buffer += this.getLastName();
		}
		return buffer;
	}

	getSortName() {
		return this.getLastName() + this.getFirstName() + this.getMiddleName();
	}	

	/** Filter for a search Term */
	accept(filter) {
		if (Array.isArray(filter)) {
			// composed search terms must match all subcomponents
			for (let i = 0; i < filter.length; i++) {
				if (this.accept(filter [i]) == false) {
					return false;
				}
			}
		} else {
			if (this.getBirthYear().toLowerCase().indexOf(filter) == -1 &&
					this.getBirthLocation().toLowerCase().indexOf(filter) == -1 &&
					this.getDeathYear().toLowerCase().indexOf(filter) == -1 &&
					this.getDeathLocation().toLowerCase().indexOf(filter) == -1 && 
					this.getFullName().toLowerCase().indexOf(filter) == -1) {
				return false;
			}
		}
		
		return true;
	}
	
	
}